export enum SalaryRequestStatus {
  Pending,
  Approved,
  Declined,
}

export enum SalaryIncreaseNotificationStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Declined = 'Declined',
  Confirmed = 'Confirmed',
  ConfirmedByDeliveryDirector = 'Confirmed by Delivery Director',
  DeclinedByDeliveryDirector = 'Declined by Delivery Director',
  DeclinedByEmployee = 'Declined by Employee',
}
